const baseUrl = process.env.VUE_APP_BASEURL
const baseUrlLiveApi = process.env.VUE_APP_LIVE_API_BASEURL
const kvSyncApiUrl = process.env.VUE_APP_AHA_SYNC_URL
const kvSyncApiBasePath = process.env.VUE_APP_AHA_SYNC_BASE_PATH
const openTokKey = process.env.VUE_APP_OPENTOK_KEY
const audienceUrl = process.env.VUE_APP_AUDIENCERURL
const gtmId = process.env.VUE_APP_GTM_ID
const unleashEndpoint = process.env.VUE_APP_UNLEASH_ENDPOINT

const thirdPartyIntegrationBaseUrl = process.env.VUE_APP_THIRD_PARTY_INTEGRATION_BASE_URL || 'http://localhost:7100/api/integrations'
const reportApiBaseUrl = process.env.VUE_APP_REPORT_API_BASE_URL || 'http://localhost:8502/api/report-app'

export default {
  baseUrl,
  liveProxyUrl: process.env.VUE_APP_LIVE_PROXY_URL || baseUrl,
  isLiveProxyUrlSet: process.env.VUE_APP_LIVE_PROXY_URL != undefined,
  kvSyncApiUrl,
  kvSyncApiBasePath,
  baseUrlLiveApi,
  region: process.env.VUE_APP_REGION || 'gb',
  env: process.env.VUE_APP_ENV,
  remoteLogUrl: process.env.VUE_APP_REMOTE_LOG_URL,
  remoteLogAuth: process.env.VUE_APP_REMOTE_LOG_AUTH,
  sentry: process.env.VUE_APP_SENTRY,
  sentryRelease: process.env.VUE_APP_GIT_COMMIT,
  domain: process.env.VUE_APP_DOMAIN,
  awsUrl: process.env.VUE_APP_AWSRURL,
  rtcUrl: process.env.VUE_APP_BASERTCURL,
  audienceUrl: process.env.VUE_APP_AUDIENCERURL,
  presenterUrl: process.env.VUE_APP_PRESENTERURL,
  baseUrlSocket: process.env.VUE_APP_BASEURLSOCKET,
  isSentryEnabled: process.env.VUE_APP_IS_SENTRY_ENABLED === 'true',
  googleRedirect: `${audienceUrl}/auth?provider=google`,
  googleClientId: process.env.VUE_APP_GOOGLE_AUTH_CLIENT_ID,
  filestack: {
    apiKey: process.env.VUE_APP_FILESTACK_API_KEY,
    bucket: process.env.VUE_APP_FILESTACK_BUCKET,
    region: process.env.VUE_APP_FILESTACK_REGION,
  },
  openTokKey,
  api: {
    googleSigninAudience: `${baseUrl}/api/auth/google/audience-google`,
    checkPresentation: `${baseUrl}/api/presentation/check/`,
    getPresentation: `${baseUrl}/api/presentation/audience/`,
    createAnswer: `${baseUrl}/api/answer/create/`,
    createOpenEndedOption: `${baseUrl}/api/slide-option/audience-create/`,
    currentOrderVoice: `${baseUrl}/api/answer/voice-number/`,
    createActionWebrtc: `${baseUrl}/api/webrtc/`,
    listSlide: `${baseUrl}/api/presentation/audience-presentation-slide-list/`,
    quizResult: `${baseUrl}/api/answer/quiz-result/`,
    slideQuizResult: `${baseUrl}/api/slide/quiz-result/`,
    joinPresentation: `${baseUrl}/api/presentation/join-presentation/`,
    createLeaderboard: `${baseUrl}/api/slide/audience-create-leaderboard/`,
    asyncLeaderboard: `${baseUrl}/api/slide/async-create-leaderboard/`,
    getTimestamp: `${baseUrl}/api/quiz/get-time-stamp/`,
    getSlideQuizTimeStamp: `${baseUrl}/api/quiz/get-slide-quiz-time-stamp/`,
    getNextSlide: `${baseUrl}/api/presentation/next-slide/`,
    createQuestion: `${baseUrl}/api/question/create/`,
    listQuestion: `${baseUrl}/api/question/list/`,
    voteQuestion: `${baseUrl}/api/question/vote/`,
    checkQuizTeamMember: `${baseUrl}/api/quiz/check-team-data/`,
    leaveQuizTeam: `${baseUrl}/api/quiz/leave-team/`,
    requestPresentation: `${baseUrl}/api/audiences/request-presentation/`,
    updateTimeAudience: `${baseUrl}/api/audiences/update-time-audience/`,
    audienceCheckAuthentication: `${baseUrl}/api/audience-authentication/check/`,
    stopVideoCall: `${baseUrl}/api/webrtc/stop/`,
    sendFeedback: `${baseUrl}/api/question/private`,
  },
  roles: ['master', 'admin', 'presenter', 'audience'],
  unleashEndpoint: unleashEndpoint || 'https://features.ahaslides.com/api/proxy',
  unleashClientKey: process.env.VUE_APP_UNLEASH_CLIENT_KEY,
  gtmId,
  mqttBrokerUrl: process.env.VUE_APP_MQTT_BROKER_URL,
  livestatsTopicPrefix: process.env.VUE_APP_LIVESTATS_TOPIC_PREFIX,
  newKafkaClusterPrefix: process.env.VUE_APP_NEWKAFKA_PREFIX, // overwrite to allow staging test
  slidePluginUrl: process.env.VUE_APP_SLIDE_PLUGIN_URL,
  allowOverridePluginUrl: process.env.VUE_APP_SLIDE_PLUGIN_URL_OVERWRITE === 'true',
  slideTypesMarketplaceUrl: process.env.VUE_APP_SLIDE_TYPES_MARKETPLACE_URL
    || 'https://aha-slide-types-creator.pages.dev/api/slide-types',
  thirdPartyIntegrationBaseUrl,
  reportApiBaseUrl,
}
